const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-597.812 -4964.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.312 5000.575h-25a5.506 5.506 0 0 1-5.5-5.5v-11.6a1.5 1.5 0 0 1 3 0v11.6a2.5 2.5 0 0 0 2.5 2.5h25a2.5 2.5 0 0 0 2.5-2.5v-4.8a1.5 1.5 0 0 1 3 0v4.8a5.506 5.506 0 0 1-5.5 5.5z",
    style: {
      fill: "#324a6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.312 4985.575a1.5 1.5 0 0 1-1.5-1.5v-14a2.5 2.5 0 0 0-2.5-2.5h-25a2.5 2.5 0 0 0-2.5 2.5v7.7a1.5 1.5 0 0 1-3 0v-7.7a5.506 5.506 0 0 1 5.5-5.5h25a5.506 5.506 0 0 1 5.5 5.5v14a1.5 1.5 0 0 1-1.5 1.5z",
    style: {
      fill: "#324a6d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(604.812 4971.575)",
    style: {
      fill: "#324a6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.812 4993.575h-3a.945.945 0 0 1-1-1v-13a.945.945 0 0 1 1-1h3a.945.945 0 0 1 1 1v13a.945.945 0 0 1-1 1z",
    style: {
      fill: "#324a6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.812 4978.575a6.369 6.369 0 0 0-4 1.5v-.5a.945.945 0 0 0-1-1h-3a.945.945 0 0 0-1 1v13a.945.945 0 0 0 1 1h3a.945.945 0 0 0 1-1v-7.5a2.5 2.5 0 0 1 5 0v7.5a.945.945 0 0 0 1 1h3a.945.945 0 0 0 1-1v-8a6.017 6.017 0 0 0-6-6z",
    style: {
      fill: "#324a6d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedin.icon.b712d5b0b6e88d628cbdada651863cc9.svg";
export { ForwardRef as ReactComponent };